import { PrimaryButton, SecondaryButton } from "@shared/buttons";
import { Modal } from "@shared/modal";

type Props = {
  title: string;
  confirmDeleteModal: boolean;
  isLoading: boolean;
  isDisabled?: boolean;
  onDeleteClick: () => void;
  onConfirmDelete: () => void;
  onCancelDelete: () => void;
};

export const ConfirmDeleteButton = ({
  confirmDeleteModal,
  isLoading,
  isDisabled,
  onDeleteClick,
  onConfirmDelete,
  onCancelDelete,
  title,
}: Props) => (
  <>
    <SecondaryButton
      loading={isLoading}
      disabled={isDisabled}
      onClick={onDeleteClick}
    >
      DELETE
    </SecondaryButton>
    <Modal
      isOpen={confirmDeleteModal}
      onClose={onCancelDelete}
      titleContent={<div className="font-bold text-xl">{title}</div>}
    >
      <div className="flex space-x-2 justify-end mt-6">
        <SecondaryButton onClick={onCancelDelete}>CANCEL</SecondaryButton>
        <PrimaryButton
          className="bg-mars hover:br-mars+1"
          onClick={onConfirmDelete}
        >
          CONFIRM
        </PrimaryButton>
      </div>
    </Modal>
  </>
);
